import { Switch } from 'react-router';
import PrivateRoute from '@/routes/PrivateRoute';
import ContractWritePage from '@/components/pages/contract/ContractWritePage';
import ContractImportPage from '@/components/pages/contract/ContractImportPage';
import ContractPage from '@/components/pages/contract/ContractPage';
import ContractListPage from '@/components/pages/contract/ContractListPage';
import { PATH_CONTRACT, PATH_CONTRACT_IMPORT, PATH_CONTRACT_INFO, PATH_CONTRACT_WRITE } from '@/constants/constant';

const ContractRoute = () => {
  return (
    <Switch>
      <PrivateRoute path={PATH_CONTRACT} exact component={ContractListPage} />
      <PrivateRoute path={PATH_CONTRACT_WRITE} exact component={ContractWritePage} />
      <PrivateRoute path={PATH_CONTRACT_IMPORT} exact component={ContractImportPage} />
      <PrivateRoute path={PATH_CONTRACT_INFO} exact component={ContractPage} />
    </Switch>
  );
};

export default ContractRoute;
